import React from 'react'
import {FolderOpenOutlined,
    EditOutlined,
    CloseOutlined,}
from "@ant-design/icons"


const Curriculum_Card = () => {
  return (
    <div>
      <div className='curriculum_card'>
            <div className='curriculum_top_div'>
                <p> Section 1 : <strong>Adds Technique</strong></p>
                    <div className='edits_div'>
                        <button className='editor_btns'>Sort lesson</button>
                        <button className='editor_btns'>Edit section</button>
                        <button className='editor_btns'>Delete section</button>
                   </div>
            </div>

            <div className='lesson_div'>
                <div className='lesson_card'>
                    <p>Lesson 1 : Pros and Cons</p>
                    <div><FolderOpenOutlined /> <EditOutlined /> <CloseOutlined /></div>
                </div>
            </div>
         </div>
    </div>
  )
}

export default Curriculum_Card
